import React from 'react';
import {connect} from 'react-redux'

import {ROLES} from '../shared/config/constants'

class ChatUIInfo extends React.Component {
  constructor (props) {
    super(props);

    this.state = {};
  }

  renderExpertModeTag () {
    return (
      <span className="chat-list-extra-context">
        <span>EXPERT MODE</span>
      </span>
    )
  }

  renderChatListCount () {
    if (typeof(this.props.chatListCount) === 'number' && this.props.chatListCount > 0) {
      return (
        <span className="chat-total-user-count">
          <i className="rc-icon-user" />
          <span>{this.props.chatListCount}</span>
        </span>
      )
    }
  }

  renderExtraContext () {
    if (this.props.currentUserRole === ROLES.EXPERT) {
      return this.renderExpertModeTag()
    }
    else {
      return this.renderChatListCount()
    }
  }

  render () {
    return (
      <span className="chat-ui-info">
        <i className="rchat-icon rc-icon-rchat" />
        <span className="chat-title">Rotoballer Live Advice</span>
        {this.renderExtraContext()}
      </span>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUserRole: state.getIn(['currentUser', 'role'], null),
    chatListCount: state.getIn(['chatListCount', 'count'], 0)
  }
}

const ChatUIInfoContainer = connect(
  mapStateToProps
)(ChatUIInfo)

export default ChatUIInfoContainer;



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/chat_ui_info.js
 **/